import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AnnouncementsTabController } from 'fragments/inbox/fragments/announcements-tab/interfaces';
import { useAPIAnnouncements } from 'services/announcements/api-announcements.service';
import { AnnouncementWithSite } from 'services/announcements/announcements.service';

export const useAnnouncementsTabController = (): AnnouncementsTabController => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { getUserAnnouncements } = useAPIAnnouncements();

    const accessToken = searchParams.get('access_token') || '';

    const [announcements, setAnnouncements] = useState<AnnouncementWithSite[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (accessToken) {
            getUserAnnouncements(accessToken)
                .then(setAnnouncements)
                .catch(() => {
                    // el errorHandler centralizado (dentro del service) ya navega en errores de red/sesión
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, [accessToken]);

    // Solo-consumo (decisión confirmada de Plan C): siempre is_admin=false, sin importar
    // el rol real del usuario en el sitio de este item puntual — la gestión de admin sigue
    // viviendo en el flujo original de Plan B (/mobile/announcements), no en el Inbox.
    const onOpen = (item: AnnouncementWithSite) =>
        navigate(`/mobile/announcements/${item.id}?access_token=${accessToken}&site_id=${item.siteId}&is_admin=false`);

    return {
        state: { announcements, loading },
        events: { onOpen },
    };
};
